import cn from 'classnames';

import stylesDesktop from './desktop.css';

export const wrapperClassNamesHelperDesktop = (isSticky?: boolean) =>
    cn({
        [stylesDesktop.wrapper]: !isSticky,
    });
